module.exports = __webpack_public_path__ + "img/logo.ab025907.png";